import { coreCustomersByIdUsersGetSlice } from './get';
import { updateCustomerUsersSyncSlice } from './update';

export const { resetGetCoreCustomersByIdUsers, repeatGetCoreCustomersByIdUsers, requestGetCoreCustomersByIdUsers } =
	coreCustomersByIdUsersGetSlice.asyncActionCreators;

export const updateCustomerUser = updateCustomerUsersSyncSlice.syncActionCreator;
